/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { RangeEdit } from "./Multiplier/Edit";
import { Range } from "./Multiplier";
import { DirectBond } from "./DirectBond";
import { PrizeBond } from "./PrizeBond";
import { TradingBond } from "./TradingBond";
import { DirectBondMemberships } from "./DirectBondMemberships";
import Navbar from "../../components/Navbar";

export const RangesIndex = () => {
  const routes = [
    { name: "Rangos", route: "/rangos" },
    { name: "Bonos Directos", route: "/rangos/bono-directo" },
    { name: "Bono Trade", route: "/rangos/bono-trade" },
    { name: "Premios", route: "/rangos/premios" },
    { name: "Bonos Directos Membresías", route: "/rangos/bono-directo-membresias" },
  ];
  return (
    <>
      <Navbar routes={routes} />
    </>
  );
};

export const RangesRoutes = [
  { path: "", Element: Range },
  { path: ":id/editar", Element: RangeEdit },
  { path: "bono-directo", Element: DirectBond },
  { path: "bono-trade", Element: TradingBond },
  { path: "premios", Element: PrizeBond },
  { path: "bono-directo-membresias", Element: DirectBondMemberships },
];
